import type { ReactElement } from "react"
import { Section, StateMessage } from "~/shared/ui"
import { unavailableContentSource } from "./ContentSource"

/**
 * Rendered so the page composes as the design shows, but deliberately empty: the
 * data lives in the myLifeway licence and media services, not the DCE graph.
 * Inventing rows here would hide the gap this prototype exists to measure.
 */
export const DownloadsSection = (): ReactElement => {
  const { status } = unavailableContentSource()

  return (
    <Section title="Downloads" qaHook="digital-library-downloads-section">
      {status === "unavailable" ? (
        <StateMessage qaHook="digital-library-downloads-unavailable">
          Downloads are not served by the DCE graph. Wiring them up is an open decision — see DCD-6988.
        </StateMessage>
      ) : null}
    </Section>
  )
}
